module.exports = __webpack_public_path__ + "static/media/orit.4479793a.jpg";